<template>
    <div class='dialog'>
        <div style="margin-bottom: 30px; display: flex; justify-content: space-between; width: 100%; align-items: center;">
            <div style="font-size: 25px; font-weight: bold; width: 70%;">
                {{ $t('order.ordering') }}
            </div>
            <div style="width: 30%">
                <img style="width: 100%" src="@/assets/image/tab/home.gif">
            </div>
        </div>
        <div style="background-color: white; padding: 10px 8px; height: 60%">
          <div class="section">
            <div class="imgStyle"></div>
            <div class="text">{{ $t('order.checkout_confirm.sell_out.' + notes.sellOutOption) }}</div>
          </div>
          <div class="section">
              <div class="imgStyle"></div>
              <div class="text">{{ $t('order.checkout_confirm.note') }}</div>
          </div>
        </div>
        <div style="margin: 0px; position: fixed; bottom: 30px; width: 90%;">
            <div @click="close" style="display: flex; align-items: center; margin: 20px; justify-content: center;">
                <div class="waitBtn">{{ $t('order.checkout_regret') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'shop-final-dialog',
  props: {
    notes: {
      type: Object,
      default () {
        return {
          sellOutOption: 'remove_item',
        }
      }
    }
  },
  methods: {
    close () {
      this.$emit('closeFinalConfirm')
    }
  }
}
</script>

<style scoped>
.dialog {
  height: 80vh;
  bottom: 0;
  background: #f4c41e;
  border-top-right-radius: 35px;
  left: 0px;
  right: 0;
  border-top-left-radius: 35px;
  padding: 30px;
}
.waitBtn {
    width: 100%;
    margin: 15px;
    display: flex;
    justify-content: center;
    background-color: #DD2C35;
	  border-radius: 30px;
    color: white;
    align-items: center;
    padding: 13px 25px;
    font-size: 18px;
    box-shadow: 0px 2px 0px 0px #B22433;
}
.imgStyle {
    background-image: url('~@/assets/image/checked.gif');
    width: 55px;
    height: 50px;
    background-repeat: no-repeat;
    background-size: 230%;
    background-position: -40px -25px;
}
.text {
    font-size: 20px;
    font-weight: bold;
    margin-left: 10px;
    margin-top: 10px;
    line-height: 30px;
    width: 80%;
}
.section {
    display: flex;
    margin-bottom: 20px;
}
</style>
